(function () {

    var initialInputValues = [];

    function isFormDirty() {
        let isDirty = false;
        $("#update-contact-info-form input:not([type=hidden])").each(function () {
            let value = $(this).is(':checkbox') ? $(this).is(':checked') : $(this).val();
            if ($(this).hasClass("phoneNumber")) {
                value = value.replace(/\D/g, '');
            }
            if (initialInputValues[$(this).attr("name")] !== value) {
                isDirty = true;
                return false;
            }
        });

        return isDirty;
    }

    $(document).ready(function () {

        if ($("#update-contact-info-modal").length) {
            $("#update-contact-info-modal").modal({ backdrop: 'static', keyboard: false });
        }
        

        $("#update-contact-info-form input:not([type=hidden])").each(function () {
            initialInputValues[$(this).attr("name")] = $(this).is(':checkbox') ? $(this).is(':checked') : $(this).val();
        });

        $(".phoneNumber").each(function () {
            $(this).val(Titania.Models.PhoneNumber.Format($(this).val()));
        });


        $('#update-contact-info-form input').keyup(debounce(function () {
            updateForm();
        }));

        $('#update-contact-info-form input[type="checkbox"]').change(debounce(function () {
            updateForm();
        }));

        function updateForm() {
            let formIsDirty = isFormDirty();

            $(".update-contact-info-modal-info-up-to-date-btn").prop('disabled', formIsDirty);

            formIsDirty ? $(".update-contact-info-modal-info-up-to-date-btn").removeClass("active") : $(".update-contact-info-modal-info-up-to-date-btn").addClass("active");
            updateSubmitButton(formIsDirty, true);
        }


        $("#update-contact-info-form").submit(function (e) {

            if (!validateAll(false)) {
                return false;
            }

            if ($("#update-contact-info-modal").length) {
                $('#update-contact-info-modal').modal('hide');
            }
        });


        $(".phoneNumber").on('keyup', function () {
            $(this).val(Titania.Models.PhoneNumber.Format($(this).val()));
        });

        function convertStringToBool(value) {
            return value && value.toLowerCase() === "true";
        }

        function validateAll(silent) {
            if (silent === undefined) {
                silent = false;
            }
            let workEmailError = $('#WorkEmail').length ? validateEmail('WorkEmail', convertStringToBool($("#workEmail_isRequired").val())) : "";
            let personalEmailError = $('#PersonalEmail').length ? validateEmail('PersonalEmail', convertStringToBool($("#personalEmail_isRequired").val())) : "";
            let workPhoneError = $('#WorkCellPhone').length ? validatePhone('WorkCellPhone', convertStringToBool($("#workPhone_isRequired").val())) : "";
            let personalPhoneError = $('#PersonalCellPhone').length ? validatePhone('PersonalCellPhone', convertStringToBool($("#personalCellPhone_isRequired").val())) : "";

            if (!silent) {
                $("#work-email-error").text(workEmailError);
                $("#personal-email-error").text(personalEmailError);
                $("#work-phone-error").text(workPhoneError);
                $("#personal-phone-error").text(personalPhoneError);
            }

            return workEmailError.length === 0 && personalEmailError.length === 0 && workPhoneError.length === 0 && personalPhoneError.length === 0;
        }

        $('#WorkEmail').on('input', debounce(function () {
            $("#work-email-error").text(validateEmail('WorkEmail'));
            $('#WorkEmailOptIn').prop("checked", !!$('#WorkEmail').val());
        }));

        $('#PersonalEmail').on('input', debounce(function () {
            $("#personal-email-error").text(validateEmail('PersonalEmail'));
            $('#PersonalEmailOptIn').prop("checked", !!$('#PersonalEmail').val());
            $('#PersonalEmailOptIn').prop("disabled", !$('#PersonalEmail').val());
        }));

        $('#WorkCellPhone').on('input', debounce(function () {
            $("#work-phone-error").text(validatePhone('WorkCellPhone'));
            $('#WorkCellPhoneOptIn').prop("checked", !!$('#WorkCellPhone').val());
        }));

        $('#PersonalCellPhone').on('input', debounce(function () {
            $("#personal-phone-error").text(validatePhone('PersonalCellPhone'));
            $('#PersonalCellPhoneOptIn').prop("checked", !!$('#PersonalCellPhone').val());
            $('#PersonalCellPhoneOptIn').prop("disabled", !$('#PersonalCellPhone').val());
        }));

        function updateSubmitButton(formIsDirty, silent) {
            if (formIsDirty && isFormValid(silent)) {
                $("#update-contact-info-modal-info-update-btn").addClass("active");
                $("#update-contact-info-modal-info-update-btn").prop('disabled', false);
                return;
            }
            $("#update-contact-info-modal-info-update-btn").removeClass("active");
            $("#update-contact-info-modal-info-update-btn").prop('disabled', true);
        }

        function isFormValid(silent) {
            return $("#work-email-error").text() === "" &&
                $("#personal-email-error").text() === "" &&
                $("#work-phone-error").text() === "" &&
                $("#personal-phone-error").text() === "" &&
                validateAll(silent);
        }

        function validatePhone(id, required) {

            const phoneObj = $("#" + id);

            if (phoneObj.is(':disabled')) {
                return "";
            }

            const phone = phoneObj.val()
                .replace(' ', '')
                .replace('(', '')
                .replace(')', '')
                .replace('-', '');

            if (!phone || !phone.length) {
                return required ? "Phone Number Required" : "";
            }

            const regex = /\(?([0-9]{3})\)?([ .-]?)([0-9]{3})\2([0-9]{4})/;

            if (!regex.test(phone)) {
                return "Invalid Phone Number";
            }

            return "";
        }

        function validateEmail(id, required) {

            const emailObj = $("#" + id);

            if (emailObj.is(':disabled')) {
                return "";
            }

            const email = emailObj.val();

            if (!email || !email.length) {
                return required ? "Email Required" : "";
            }

            const regex = /^([a-zA-Z0-9_.+-])+\@(([a-zA-Z0-9-])+\.)+([a-zA-Z0-9]{2,4})+$/;
            return regex.test(email) ? "" : "Invalid Email";
        }

        function debounce(func) {
            var timeout;
            return function () {
                clearTimeout(timeout);
                timeout = null;
                timeout = setTimeout(func, 200);
            };
        }

        $('#PersonalEmailOptIn').prop("disabled", !$('#PersonalEmail').val());
        $('#PersonalCellPhoneOptIn').prop("disabled", !$('#PersonalCellPhone').val());

        validateAll(false);
    });
})();